import { MOCK_HYBRID_CONVERSION_API, expected } from '@aloft/toolkit-shared';

import { useCreateMockHybridConversionOrderAPI } from '../../../../../hooks/api/toolkitComponents.ts';

export const useCreateMockHybridConversionOrder = (): ((
  originalOrderId: string,
) => Promise<string>) => {
  const mutation = useCreateMockHybridConversionOrderAPI();

  return async (originalOrderId) => {
    const body = MOCK_HYBRID_CONVERSION_API.POST.REQUEST.BODY.parse({ originalOrderId });
    const res = await mutation.mutateAsync({ body });
    const parsed = MOCK_HYBRID_CONVERSION_API.POST.RESPONSE.parse(res);
    return expected(parsed.id);
  };
};
